var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myContract"},[_c('my-contract-tabs',{scopedSlots:_vm._u([{key:"headerLeft",fn:function(){return [_c('OrderContract')]},proxy:true},{key:"headerRight",fn:function(){return [_c('OtherContract')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }